export const RoutePostFixtureGuessing = "/fixtures-guessing";

export interface PayloadPostFixturesGuessing {
  categoryId: number;
  storeIds: number[];
  configuration: {
    optimizeOnInitialFixtures: boolean;
    stackToMax: boolean;
    shelvesAlignmentWeight: number;
    shelvesEstimationStrategy: "conservative" | "balanced" | "aggressive" | "min_dos_only";
  };
}

export interface ResponsePostFixturesGuessing {
  fixtureGuessingTriggerId: number;
}

export const RouteGetFixturesGuessing = "/fixtures-guessing";

export interface QueryParamsGetFixturesGuessing {
  categoryId: string;
}

export interface ResponseGetFixturesGuessingItem {
  storeId: number;
  storeCode: string;
  baySize: number;
  updatedDate: Date | null;
  fixtureGuessingTriggerId: number | null;
  fixtureGuessingId: number | null;
  status: "NOT_STARTED" | "IN_PROGRESS" | "DONE" | "ERROR";
}

export type ResponseGetFixturesGuessing = ResponseGetFixturesGuessingItem[];
